export const marketplaceMock = {
  tenants: [
    {
      id: 'tenant-axodus-dao',
      name: 'Axodus DAO',
      type: 'constitutional-root',
      governanceStanding: 'verified',
      treasuryDestination: 'Axodus Treasury',
      constitutionalStanding: 'aligned',
      reviewAuthority: 'Governance Ops',
    },
    {
      id: 'tenant-academy-dao',
      name: 'Academy DAO',
      type: 'federated-dao',
      governanceStanding: 'under-review',
      treasuryDestination: 'Academy DAO Treasury',
      constitutionalStanding: 'requires-review',
      reviewAuthority: 'Academy Governance Review',
    },
    {
      id: 'tenant-mcp-working-group',
      name: 'MCP Working Group',
      type: 'working-group',
      governanceStanding: 'warning',
      treasuryDestination: 'MCP Review Escrow',
      constitutionalStanding: 'requires-review',
      reviewAuthority: 'ACS Plugin Audit',
    },
  ],
  sellers: [
    {
      id: 'seller-axodus-core',
      name: 'Axodus Nucleus',
      type: 'Internal Axodus Nucleus',
      verificationStatus: 'internal',
      governanceStanding: 'verified',
      reputation: 98,
      registeredDAOs: ['Axodus DAO'],
      tenantId: 'tenant-axodus-dao',
      productsPublished: 12,
      constitutionalBound: true,
      treasuryLinked: true,
      riskScore: 4,
      description: 'Internal marketplace publisher for governance-approved NFT access and ecosystem capabilities.',
    },
    {
      id: 'seller-academy-guild',
      name: 'Academy Tutor Guild',
      type: 'DAO',
      verificationStatus: 'verified',
      governanceStanding: 'verified',
      reputation: 91,
      registeredDAOs: ['Academy DAO'],
      tenantId: 'tenant-academy-dao',
      productsPublished: 8,
      constitutionalBound: true,
      treasuryLinked: true,
      riskScore: 9,
      description: 'Tutor collective distributing ERC1155 certification packs and NFT-gated learning assets.',
    },
    {
      id: 'seller-mcp-labs',
      name: 'MCP Runtime Labs',
      type: 'Partner',
      verificationStatus: 'pending',
      governanceStanding: 'warning',
      reputation: 76,
      registeredDAOs: ['MCP Working Group'],
      tenantId: 'tenant-mcp-working-group',
      productsPublished: 4,
      constitutionalBound: true,
      treasuryLinked: false,
      riskScore: 28,
      description: 'Partner team preparing agent templates and runtime integrations for governance review.',
    },
  ],
  licenses: [
    {
      id: 'license-personal-nft',
      type: 'NFT Access License',
      transferable: true,
      revokable: false,
      nftBound: true,
      expiration: null,
      governanceControlled: true,
      permissions: ['view-content', 'request-signed-url', 'secondary-transfer-preview'],
      ownershipModel: 'wallet',
    },
    {
      id: 'license-dao-plugin',
      type: 'DAO License',
      transferable: false,
      revokable: true,
      nftBound: true,
      expiration: '2027-01-01T00:00:00.000Z',
      governanceControlled: true,
      permissions: ['install-plugin', 'dao-seat-access', 'audit-log-export'],
      ownershipModel: 'dao',
    },
    {
      id: 'license-enterprise',
      type: 'Enterprise License',
      transferable: false,
      revokable: true,
      nftBound: false,
      expiration: '2026-12-31T00:00:00.000Z',
      governanceControlled: true,
      permissions: ['team-access', 'signed-url-preview', 'support-routing'],
      ownershipModel: 'enterprise-seat',
    },
  ],
  products: [
    {
      id: 'product-governance-dashboard-nft',
      title: 'Governance Dashboard NFT Access',
      slug: 'governance-dashboard-nft-access',
      category: 'Governance',
      subcategory: 'Governance dashboards',
      sellerId: 'seller-axodus-core',
      tenantId: 'tenant-axodus-dao',
      description: 'ERC721-gated access pass for governance dashboard modules, treasury visibility previews, and voting analytics.',
      shortDescription: 'NFT access pass for governance dashboards and treasury visibility.',
      tags: ['governance', 'dashboard', 'erc721', 'treasury'],
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1200&q=80',
      version: '0.1.0',
      status: 'listed',
      lifecycleStatus: 'approved',
      governanceLifecycle: 'approved',
      purchaseLifecycle: 'eligible',
      licenseLifecycle: 'active',
      billingLifecycle: 'invoice-preview',
      governanceStatus: 'compliant',
      constitutionalStanding: 'aligned',
      visibility: 'public',
      pricing: { amount: 120, currency: 'USDC', settlementMode: 'mock-only' },
      daoOwner: 'Axodus DAO',
      treasuryDestination: 'Axodus Treasury / Governance Revenue',
      executionType: 'Fixed listing',
      subscriptionStatus: 'one-time access',
      operationalRisk: 'low',
      acsValidationState: 'validated',
      acceptedCurrencies: ['USDC', 'NRS'],
      royaltyModel: { standard: 'EIP-2981', bps: 500, recipient: 'Axodus Treasury', previewAmount: 6 },
      accessModel: 'wallet-gated',
      deliveryType: 'Signed URL',
      licenseType: 'NFT Access License',
      supportedChains: ['Ethereum', 'Polygon', 'Arbitrum'],
      nftBound: true,
      governanceRequired: true,
      maturity: 'beta',
      tokenStandard: 'ERC721',
      contractAddress: 'mock:governance-dashboard-access',
      tokenId: 'AXD-GOV-001',
      listingType: 'fixed',
      bridgeReadiness: { layerZeroReady: true, sourceChain: 'Polygon', destinationChains: ['Ethereum', 'Arbitrum'] },
      greenfieldBucket: 'mock-greenfield-governance-access',
      signedUrlPreviewAvailable: true,
      createdAt: '2026-05-01T10:00:00.000Z',
      updatedAt: '2026-05-18T13:00:00.000Z',
      validationStatus: 'approved',
    },
    {
      id: 'product-academy-cert-bundle',
      title: 'Academy Certification ERC1155 Bundle',
      slug: 'academy-certification-erc1155-bundle',
      category: 'Education',
      subcategory: 'Certification packs',
      sellerId: 'seller-academy-guild',
      tenantId: 'tenant-academy-dao',
      description: 'ERC1155 certification pack for governance education, Proof of Knowledge compatibility, and gated learning content.',
      shortDescription: 'ERC1155 certification pack with Academy and PoK compatibility.',
      tags: ['academy', 'certification', 'erc1155', 'pok'],
      image: 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?auto=format&fit=crop&w=1200&q=80',
      version: '0.2.0',
      status: 'listed',
      lifecycleStatus: 'pending-validation',
      governanceLifecycle: 'under-review',
      purchaseLifecycle: 'validating',
      licenseLifecycle: 'preview',
      billingLifecycle: 'invoice-preview',
      governanceStatus: 'under-review',
      constitutionalStanding: 'requires-review',
      visibility: 'dao-gated',
      pricing: { amount: 80, currency: 'USDC', settlementMode: 'mock-only' },
      daoOwner: 'Academy DAO',
      treasuryDestination: 'Academy DAO / Tutor Revenue Split',
      executionType: 'English auction',
      subscriptionStatus: 'renewable access',
      operationalRisk: 'medium',
      acsValidationState: 'metadata-review',
      acceptedCurrencies: ['USDC', 'NRS'],
      royaltyModel: { standard: 'EIP-2981', bps: 700, recipient: 'Academy DAO', previewAmount: 5.6 },
      accessModel: 'dao-gated',
      deliveryType: 'Greenfield',
      licenseType: 'Subscription License',
      supportedChains: ['BNB', 'Polygon'],
      nftBound: true,
      governanceRequired: true,
      maturity: 'beta',
      tokenStandard: 'ERC1155',
      contractAddress: 'mock:academy-certification-bundle',
      tokenId: 'AXD-ACADEMY-1155',
      listingType: 'english-auction',
      auction: { type: 'english-auction', status: 'active', reservePrice: 60, highestBid: 92, bidCount: 17, endsAt: '2026-06-01T18:00:00.000Z' },
      bridgeReadiness: { layerZeroReady: true, sourceChain: 'BNB', destinationChains: ['Polygon'] },
      greenfieldBucket: 'mock-greenfield-academy-content',
      signedUrlPreviewAvailable: true,
      createdAt: '2026-05-04T12:00:00.000Z',
      updatedAt: '2026-05-18T15:20:00.000Z',
      validationStatus: 'under-review',
    },
    {
      id: 'product-mcp-agent-template',
      title: 'MCP Agent Template License',
      slug: 'mcp-agent-template-license',
      category: 'MCPs',
      subcategory: 'Agent templates',
      sellerId: 'seller-mcp-labs',
      tenantId: 'tenant-mcp-working-group',
      description: 'Governance-reviewed agent template package with plugin compatibility checks and future DAO installation rights.',
      shortDescription: 'MCP agent template license with plugin review status.',
      tags: ['mcp', 'agent', 'plugin', 'runtime'],
      image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1200&q=80',
      version: '0.1.0',
      status: 'listed',
      lifecycleStatus: 'restricted',
      governanceLifecycle: 'restricted',
      purchaseLifecycle: 'failed-mock',
      licenseLifecycle: 'suspended',
      billingLifecycle: 'failed-mock',
      governanceStatus: 'restricted',
      constitutionalStanding: 'requires-review',
      visibility: 'private-preview',
      pricing: { amount: 250, currency: 'USDC', settlementMode: 'mock-only' },
      daoOwner: 'MCP Working Group',
      treasuryDestination: 'MCP Working Group / Review Escrow',
      executionType: 'License preview',
      subscriptionStatus: 'installation-gated',
      operationalRisk: 'high',
      acsValidationState: 'plugin-audit-required',
      acceptedCurrencies: ['USDC'],
      royaltyModel: { standard: 'Custom Split', bps: 1000, recipient: 'MCP Working Group', previewAmount: 25 },
      accessModel: 'license-key',
      deliveryType: 'MCP Runtime',
      licenseType: 'DAO License',
      supportedChains: ['Arbitrum', 'Polygon'],
      nftBound: false,
      governanceRequired: true,
      maturity: 'alpha',
      tokenStandard: 'OffchainLicense',
      listingType: 'license-preview',
      bridgeReadiness: { layerZeroReady: false, sourceChain: 'Arbitrum', destinationChains: [] },
      signedUrlPreviewAvailable: false,
      createdAt: '2026-05-06T09:30:00.000Z',
      updatedAt: '2026-05-18T17:00:00.000Z',
      validationStatus: 'restricted',
    },
    {
      id: 'product-trading-strategy-pass',
      title: 'Strategy License Dutch Auction',
      slug: 'strategy-license-dutch-auction',
      category: 'Trading',
      subcategory: 'Strategy licenses',
      sellerId: 'seller-axodus-core',
      tenantId: 'tenant-axodus-dao',
      description: 'Mock dutch auction for a strategy license NFT, with risk-aware listing metadata and no live trading execution.',
      shortDescription: 'Dutch auction preview for a risk-reviewed strategy license NFT.',
      tags: ['trading', 'strategy', 'auction', 'erc721'],
      image: 'https://images.unsplash.com/photo-1642790551116-18e150f248e5?auto=format&fit=crop&w=1200&q=80',
      version: '0.1.0',
      status: 'listed',
      lifecycleStatus: 'pending-validation',
      governanceLifecycle: 'warning',
      purchaseLifecycle: 'validating',
      licenseLifecycle: 'preview',
      billingLifecycle: 'invoice-preview',
      governanceStatus: 'under-review',
      constitutionalStanding: 'requires-review',
      visibility: 'public',
      pricing: { amount: 300, currency: 'USDC', settlementMode: 'mock-only' },
      daoOwner: 'Axodus DAO',
      treasuryDestination: 'Axodus Treasury / Strategy Licensing',
      executionType: 'Dutch auction',
      subscriptionStatus: 'personal license',
      operationalRisk: 'medium',
      acsValidationState: 'risk-review',
      acceptedCurrencies: ['USDC'],
      royaltyModel: { standard: 'EIP-2981', bps: 400, recipient: 'Axodus Treasury', previewAmount: 12 },
      accessModel: 'wallet-gated',
      deliveryType: 'Dashboard Access',
      licenseType: 'Personal Use',
      supportedChains: ['Ethereum', 'Arbitrum'],
      nftBound: true,
      governanceRequired: true,
      maturity: 'alpha',
      tokenStandard: 'ERC721',
      contractAddress: 'mock:strategy-license-pass',
      tokenId: 'AXD-STRAT-007',
      listingType: 'dutch-auction',
      auction: { type: 'dutch-auction', status: 'active', reservePrice: 180, highestBid: 220, bidCount: 6, endsAt: '2026-05-30T18:00:00.000Z' },
      bridgeReadiness: { layerZeroReady: true, sourceChain: 'Arbitrum', destinationChains: ['Ethereum'] },
      signedUrlPreviewAvailable: false,
      createdAt: '2026-05-07T11:15:00.000Z',
      updatedAt: '2026-05-18T18:10:00.000Z',
      validationStatus: 'risk-review',
    },
  ],
  boundaries: [
    { id: 'reown', label: 'Reown AppKit wallet state', status: 'mocked', description: 'Wallet connection, account and chain state are mocked for UI readiness.' },
    { id: 'contracts', label: 'MarketplaceContractAdapter', status: 'ready-boundary', description: 'Fixed listings, buy-now, auctions and bid methods are interface-ready with mock responses.' },
    { id: 'royalties', label: 'RoyaltyService', status: 'ready-boundary', description: 'EIP-2981 royalty previews are calculated from mock listing prices.' },
    { id: 'greenfield', label: 'Greenfield delivery', status: 'mocked', description: 'Greenfield buckets and signed URL previews are shown after mock purchase.' },
    { id: 'layerzero', label: 'LayerZero bridge readiness', status: 'deferred', description: 'Supported chains and bridge readiness are exposed without bridge execution.' },
  ],
  orders: [
    {
      id: 'order-mkt-001',
      productId: 'product-governance-dashboard-nft',
      buyer: '0xAxoD...Mock',
      daoContext: 'Axodus DAO',
      status: 'review-queued',
      purchaseLifecycle: 'preview-issued',
      billingLifecycle: 'invoice-preview',
      licenseLifecycle: 'issued',
      amount: 120,
      currency: 'USDC',
      settlementMode: 'mock-only',
      licenseIssued: 'license-personal-nft',
      governanceReviewRequired: true,
      treasuryDestination: 'Axodus Treasury / Governance Revenue',
      createdAt: '2026-05-18T13:20:00.000Z',
    },
    {
      id: 'order-mkt-002',
      productId: 'product-academy-cert-bundle',
      buyer: 'academy-dao-ops',
      daoContext: 'Academy DAO',
      status: 'pending-validation',
      purchaseLifecycle: 'validating',
      billingLifecycle: 'invoice-preview',
      licenseLifecycle: 'preview',
      amount: 92,
      currency: 'USDC',
      settlementMode: 'mock-only',
      licenseIssued: 'pending-auction-settlement',
      governanceReviewRequired: true,
      treasuryDestination: 'Academy DAO / Tutor Revenue Split',
      createdAt: '2026-05-18T15:45:00.000Z',
    },
    {
      id: 'order-mkt-003',
      productId: 'product-mcp-agent-template',
      buyer: 'mcp-working-group',
      daoContext: 'MCP Working Group',
      status: 'blocked',
      purchaseLifecycle: 'failed-mock',
      billingLifecycle: 'failed-mock',
      licenseLifecycle: 'suspended',
      amount: 250,
      currency: 'USDC',
      settlementMode: 'mock-only',
      licenseIssued: 'blocked-by-plugin-audit',
      governanceReviewRequired: true,
      treasuryDestination: 'MCP Working Group / Review Escrow',
      createdAt: '2026-05-18T17:10:00.000Z',
    },
  ],
  subscriptions: [
    {
      id: 'sub-mkt-001',
      productId: 'product-academy-cert-bundle',
      holder: 'Academy DAO',
      plan: 'Certification access',
      status: 'review-ready',
      subscriptionLifecycle: 'trial-mock-preview',
      billingLifecycle: 'invoice-preview',
      licenseLifecycle: 'preview',
      renewalCycle: 'monthly',
      nextReviewAt: '2026-06-18T00:00:00.000Z',
      accessScope: 'DAO learners',
      treasuryDestination: 'Academy DAO / Tutor Revenue Split',
      governanceStanding: 'under-review',
    },
    {
      id: 'sub-mkt-002',
      productId: 'product-mcp-agent-template',
      holder: 'MCP Working Group',
      plan: 'Plugin installation seats',
      status: 'restricted',
      subscriptionLifecycle: 'paused',
      billingLifecycle: 'failed-mock',
      licenseLifecycle: 'suspended',
      renewalCycle: 'quarterly',
      nextReviewAt: '2026-07-01T00:00:00.000Z',
      accessScope: 'DAO operators',
      treasuryDestination: 'MCP Working Group / Review Escrow',
      governanceStanding: 'restricted',
    },
  ],
  treasuryRoutes: [
    {
      id: 'treasury-route-001',
      destination: 'Axodus Treasury / Governance Revenue',
      daoOwner: 'Axodus DAO',
      routeType: 'protocol-fee-preview',
      allocationPreview: '5% royalty + protocol fee preview',
      status: 'compliant',
      settlementMode: 'mock-only',
      accountingHook: 'marketplace.protocolRevenue.preview',
    },
    {
      id: 'treasury-route-002',
      destination: 'Academy DAO / Tutor Revenue Split',
      daoOwner: 'Academy DAO',
      routeType: 'creator-split-preview',
      allocationPreview: 'Tutor share + Academy DAO allocation',
      status: 'under-review',
      settlementMode: 'mock-only',
      accountingHook: 'academy.certificationRevenue.preview',
    },
    {
      id: 'treasury-route-003',
      destination: 'MCP Working Group / Review Escrow',
      daoOwner: 'MCP Working Group',
      routeType: 'review-escrow-preview',
      allocationPreview: 'Escrow preview until plugin audit clears',
      status: 'restricted',
      settlementMode: 'mock-only',
      accountingHook: 'mcp.pluginEscrow.preview',
    },
  ],
  publisherQueue: [
    {
      id: 'publisher-task-001',
      sellerId: 'seller-axodus-core',
      productId: 'product-governance-dashboard-nft',
      title: 'Governance Dashboard NFT metadata refresh',
      status: 'ready-boundary',
      requiredReviews: ['constitutional', 'treasury'],
      targetRegistry: 'ERC721 access registry',
      metadataState: 'ready',
      publishingScope: 'metadata-refresh',
      escalationTarget: 'Governance Ops',
      blocker: null,
      submittedAt: '2026-05-18T14:00:00.000Z',
    },
    {
      id: 'publisher-task-002',
      sellerId: 'seller-academy-guild',
      productId: 'product-academy-cert-bundle',
      title: 'Academy certification delivery update',
      status: 'metadata-review',
      requiredReviews: ['academy', 'acs', 'governance'],
      targetRegistry: 'ERC1155 certification registry',
      metadataState: 'requires-proof-note',
      publishingScope: 'delivery-policy-update',
      escalationTarget: 'Academy Governance Review',
      blocker: 'Proof of Knowledge compatibility note pending',
      submittedAt: '2026-05-18T16:00:00.000Z',
    },
    {
      id: 'publisher-task-003',
      sellerId: 'seller-mcp-labs',
      productId: 'product-mcp-agent-template',
      title: 'MCP agent template plugin listing',
      status: 'plugin-audit-required',
      requiredReviews: ['acs', 'plugin-security', 'dao-approval'],
      targetRegistry: 'DAO plugin license registry',
      metadataState: 'plugin-scope-incomplete',
      publishingScope: 'new-plugin-listing',
      escalationTarget: 'ACS Plugin Audit',
      blocker: 'Plugin capability scope not cleared',
      submittedAt: '2026-05-18T18:00:00.000Z',
    },
  ],
};
